import React from "react";
import { Grid, Segment } from "semantic-ui-react";
import logo from "../../assets/icons/logo-transparent.svg";

export default function Footer() {
  return (
    <Segment vertical className="footer-container">
      <Grid container inverted stackable>
        <Grid.Row>
          <Grid.Column width={5} only={"computer tablet"}>
            <img
              className="footer-hello-radius-logo"
              src={logo}
              alt="hello radius logo"
              data-testid="hello-radius-logo-image-testid"
            />
            <div className="white-text" style={{ marginTop: 13 }}>
              Connecting teams to the right talent
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="footer-copyright-text">
          <Grid.Column width={5}>
            © 2025 Hello Radius Limited. All rights reserved.
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
